import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";

export function createTourPreReqReducer(
    state = initialState.createTourPreReq, action
) {
    switch(action.type) {
        case types.FETCH_CREATE_TOUR_PRE_REQ_SUCCESS:
            return action.createTourPreReq;
        default:
            return state;
    }
}

export function tourReducer(
    state = initialState.tour, action
) {
    switch(action.type) {
        case types.ADD_TOUR_SUCCESS:
            return action.tour;
        case types.REMOVE_TOUR_SUCCESS:
            return action.response;
        case types.EDIT_TOUR_SUCCESS:
            return action.response;
        case types.FETCH_TOUR_SUCCESS:
            return action.tour;
        default:
            return state;
    }
}

export function activeToursReducer(
    state = initialState.activeTours, action
) {
    switch(action.type) {
        case types.FETCH_ACTIVE_TOURS_SUCCESS:
            return action.activeTours;
        default:
            return state;
    }
}

export function defaultTourLengthReducer(
    state = initialState.defaultTourLength, action
) {
    switch(action.type) {
        case types.FETCH_DEFAULT_TOUR_LENGTH_SUCCESS:
            return action.defaultTourLength;
        default:
            return state;
    }
}

export function tourActivityFlagReducer(
    state = initialState.tourActivityFlag, action
) {
    switch(action.type) {
        case types.ADD_TOUR_ACTIVITY_FLAG_SUCCESS:
            return action.response;
        case types.REMOVE_TOUR_ACTIVITY_FLAG_SUCCESS:
            return action.response;
        case types.EDIT_TOUR_ACTIVITY_FLAG_SUCCESS:
            return action.response;
        case types.FETCH_TOUR_ACTIVITY_FLAG_SUCCESS:
            return action.tourActivityFlag;
        default:
            return state;
    }
}

export function tourIndicatorsReducer(
    state = initialState.tourIndicators, action
) {
    switch(action.type) {
        case types.FETCH_TOUR_INDICATORS_SUCCESS:
            return action.tourIndicators;
        default:
            return state;
    }
}

export function tourIndicatorReducer(
    state = initialState.tourIndicator, action
) {
    switch(action.type) {
        case types.ADD_TOUR_INDICATOR_SUCCESS:
            return action.response;
        case types.REMOVE_TOUR_INDICATOR_SUCCESS:
            return action.response;
        case types.FETCH_TOUR_INDICATOR_SUCCESS:
            return action.tourIndicator;
        case types.EDIT_TOUR_INDICATOR_SUCCESS:
            return action.tourIndicator;
        default:
            return state;
    }
}

export function tourPayTransactionsReducer(
    state = initialState.tourPayTransactions, action
) {
    switch(action.type) {
        case types.FETCH_TOUR_PAY_TRANSACTIONS_SUCCESS:
            return action.tourPayTransactions;
        default:
            return state;
    }
}

export function tourPayTransactionReducer(
    state = initialState.tourPayTransaction, action
) {
    switch(action.type) {
        case types.ADD_TOUR_PAY_TRANSACTION_SUCCESS:
            return action.response;
        case types.REMOVE_TOUR_PAY_TRANSACTION_SUCCESS:
            return action.response;
        case types.FETCH_TOUR_PAY_TRANSACTION_SUCCESS:
            return action.tourPayTransaction;
        case types.EDIT_TOUR_PAY_TRANSACTION_SUCCESS:
            return action.tourPayTransaction;
        default:
            return state;
    }
}

export function activityFlagByTourReducer(
    state = initialState.activityFlagByTour, action
) {
    switch(action.type) {
        case types.FETCH_ACTIVITY_FLAG_BY_TOUR_SUCCESS:
            return action.activityFlagByTour;
        default:
            return state;
    }
}

export function tourActivityFlagsReducer(
    state = initialState.tourActivityFlags, action
) {
    switch(action.type) {
        case types.FETCH_TOUR_ACTIVITY_FLAGS_SUCCESS:
            return action.tourActivityFlags;
        default:
            return state;
    }
}

export function codesByIndicatorReducer(
    state = initialState.codesByIndicator, action
) {
    switch(action.type) {
        case types.FETCH_CODES_BY_INDICATOR_SUCCESS:
            return action.codesByIndicator;
        default:
            return state;
    }
}

export function indicatorsByIdReducer(
    state = initialState.indicatorsById, action
) {
    switch(action.type) {
        case types.FETCH_INDICATORS_BY_ID_SUCCESS:
            return action.indicatorsById;
        default:
            return state;
    }
}

export function indicatorsByTourReducer(
    state = initialState.indicatorsByTour, action
) {
    switch(action.type) {
        case types.FETCH_INDICATORS_BY_TOUR_SUCCESS:
            return action.indicatorsByTour;
        default:
            return state;
    }
}

export function jobElementsByTourReducer(
    state = initialState.jobElementsByTour, action
) {
    switch(action.type) {
        case types.FETCH_JOB_ELEMENTS_BY_TOUR_SUCCESS:
            return action.jobElementsByTour;
        default:
            return state;
    }
}

export function tourMealsReducer(
    state = initialState.tourMeals, action
) {
    switch(action.type) {
        case types.FETCH_TOUR_MEALS_SUCCESS:
            return action.tourMeals;
        default:
            return state;
    }
}

export function payTransactionsByTourReducer(
    state = initialState.payTransactionsByTour, action
) {
    switch(action.type) {
        case types.FETCH_PAY_TRANSACTIONS_BY_TOUR_SUCCESS:
            return action.payTransactionsByTour;
        default:
            return state;
    }
}

export function ifToursAreInDateRangeReducer(
    state = initialState.ifToursAreInDateRange, action
) {
    switch(action.type) {
        case types.FETCH_IF_TOURS_ARE_IN_DATE_RANGE:
            return action.tours;
        default:
            return state;
    }
}


